import React, { useState } from "react";
import "./Pagination_holder.css";

function Pagination_holder({ totalPages = 5, onPageChange }) {
  const [currentPage, setCurrentPage] = useState(1);

  // Handles page click
  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      if (onPageChange) {
        onPageChange(page); // Notify the parent component
      }
    }
  };

  // Renders page numbers
  const renderPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={currentPage === i ? "active" : ""}
          onClick={() => handlePageClick(i)}
        >
          {i}
        </li>
      );
    }
    return pageNumbers;
  };

  return (
    <section className="Pagination_holder">
      <nav>
        <ul className="pagination">
          {/* Previous Button */}
          <li
            className={
              currentPage === 1 ? "disabled " : "navigation-btn-holder"
            }
            onClick={() => handlePageClick(currentPage - 1)}
          >
            {"<"}
          </li>

          {/* Page Numbers */}
          {renderPageNumbers()}

          {/* Next Button */}
          <li
            className={
              currentPage === totalPages ? "disabled " : "navigation-btn-holder"
            }
            onClick={() => handlePageClick(currentPage + 1)}
          >
            {">"}
          </li>
        </ul>
      </nav>
    </section>
  );
}

export default Pagination_holder;
